// extracted by mini-css-extract-plugin
export var arrow = "_ls-1";
export var content = "_ls-0";
export var highlighted = "_ls-2";